import { Component, OnInit } from '@angular/core';

import { ActivatedRoute, Router } from '@angular/router';



/**

 * Rota legada — redireciona para o wizard na etapa de confirmação (5/5).

 */

@Component({

  standalone: false,

  selector: 'app-project-register-confirmation',

  template: '',

})

export class ProjectRegisterConfirmationComponent implements OnInit {

  constructor(

    private route: ActivatedRoute,

    private router: Router,

  ) {}



  ngOnInit(): void {

    const id = this.route.snapshot.paramMap.get('id');

    if (!id) {

      this.router.navigate(['/registro-projeto']);

      return;

    }



    this.router.navigate(['/registro-projeto', id], {

      queryParams: { step: 4 },

      replaceUrl: true,

    });

  }

}

